import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type THIS_API = ApiDefinition['/workflows/user-workflows/{userWorkflowId}/generate-petition-pdf']['POST'];
type Input = THIS_API['params'] & THIS_API['body'];
type Output = THIS_API['response'];

const generatePetitionPdf = async ({ userWorkflowId, documents }: Input): Promise<Output> => {
  const response = await noodleApiClient.post(`/workflows/user-workflows/${userWorkflowId}/generate-petition-pdf`, {
    documents,
  });
  return response.data;
};

export default generatePetitionPdf;
